import styled, { withProps } from 'ui/styled';

export const SelectedAppWrapper = withProps<{ isDP360Collapsed: boolean }>(styled.div)`
  transition: all .2s linear;
  display: flex;
  height: 100%;
  ${({ isDP360Collapsed }) =>
    isDP360Collapsed
      ? `
      width: 48px;
      flex-grow: 0;
      flex-shrink: 0;
    `
      : `
      flex-grow: 2;
      flex-shrink: 2;
      @media only screen and (min-width: 1280px)  {
        width: 480px;
      };
      @media only screen and (max-width: 1280px) and (min-width: 1024px)  {
        width: 425px;
      };
      @media only screen and (max-width: 1024px) {
        width: 360px;
      };
    `};
`;

export const OverflowContent = withProps<{ show?: boolean }>(styled.div)`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 4px;
  width: 100%;
  display: ${({ show }) => (show ? 'block' : 'none')};
  @media only screen and (max-width: 1024px) {
    background: ${({ theme }) => theme.datashop.palette.white.main};
    padding: 8px;
    border-left: 1px solid ${({ theme }) => theme.datashop.palette.stone.light};;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    z-index: 1;
  };
`;

export const AppContainer = withProps<{ show?: boolean }>(styled.div)`
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

export const PopupContainer = styled.div`
  display: flex;
  justify-content: center;
`;
